import {
    PUSH_TOKEN,
    RESET_TOKEN
} from "./types";

export const pushToken = (token) => ({
    type: PUSH_TOKEN,
    payload: token
});

export const flushToken = () => ({
    type: PUSH_TOKEN,
    payload: ""
});

export const resetToken = () => ({
    type: RESET_TOKEN,
    payload: ""
});